import React from 'react'
import { useSelector } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'
import SpeedDial from '@material-ui/lab/SpeedDial'
import SpeedDialIcon from '@material-ui/lab/SpeedDialIcon'
import SpeedDialAction from '@material-ui/lab/SpeedDialAction'
import { PersonAdd } from '@material-ui/icons'
import PropTypes from 'prop-types'
import { primaryColor, secondaryColor } from '../../../../constants'
import IntelMsg from '../../../ItelMsg'
import { MENU_ITEMS_TANK } from '../../../tank/dummies/menuItems'
import { MENU_ITEMS } from '../../../../dummies/menuItems'

const useStyles = makeStyles((theme) => ({
  radioGroup: {
    margin: theme.spacing(1, 0),
  },
  speedDial: {
    position: 'fixed',
    'z-index': '900',

    '&.MuiSpeedDial-directionUp, &.MuiSpeedDial-directionLeft': {
      bottom: theme.spacing(2),
      right: theme.spacing(8),
    },
    '&.MuiSpeedDial-directionDown, &.MuiSpeedDial-directionRight': {
      top: theme.spacing(2),
      left: theme.spacing(2),
    },
    '& > button': {
      backgroundColor: primaryColor,
    },
    '& > button:hover': {
      backgroundColor: secondaryColor,
    },
  },
}))

const SpeedDials = ({ show, setShow }) => {
  const productName = localStorage.getItem('product')
  const { userRole } = useSelector((store) => ({
    userRole: store.auth.userRole,
  }))
  const classes = useStyles()
  const [open, setOpen] = React.useState(false)

  const handleClose = () => {
    setOpen(false)
  }

  const handleOpen = () => {
    setOpen(true)
  }

  const customerSpeedDial = (
    <SpeedDial
      ariaLabel="actions"
      className={classes.speedDial}
      hidden={show}
      icon={<SpeedDialIcon />}
      onClose={handleClose}
      onOpen={handleOpen}
      open={open}
      direction="up"
      FabProps={{ backgroundColor: primaryColor }}
    >
      <SpeedDialAction
        key="Add Customer"
        icon={<PersonAdd />}
        tooltipTitle={
          <h5>
            <IntelMsg id="addCustomerAction" />
          </h5>
        }
        onClick={() => {
          handleClose()
          setShow(true)
        }}
      />
    </SpeedDial>
  )

  const renderSpeedDial = () => {
    if (productName === 'tank') {
      const item = MENU_ITEMS_TANK.find((el) => el.name === 'companyManagement')
      const roles = item.role.split(',')
      if (roles.includes(userRole)) return customerSpeedDial
      return null
    }
    if (productName === 'cold') {
      const item = MENU_ITEMS.find((el) => el.name === 'companyManagement')
      const roles = item.role.split(',')
      if (roles.includes(userRole)) return customerSpeedDial
      return null
    }
    return null
  }

  return <>{renderSpeedDial()}</>
}

SpeedDials.propTypes = {
  setShow: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
}
export default SpeedDials
